<template>
  <div class="quote-popup-content">
    <h1 class="quote-popup-content__header">
      <slot name="header"></slot>
    </h1>
    <div class="quote-popup-content__body">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
  @import './QuotePopupContent';
</style>
